import React, { useEffect } from 'react';
import { ISearchResultsRowMap } from '../utils';
import WellDropImageLoader from 'components/searchAndFilter/components/WellDropImageLoader';

interface Props {
  latestSelectedRow: ISearchResultsRowMap;
  onImageAvailable?: (available: boolean) => void;
}
const ImgView = (props: Props) => {
  const { latestSelectedRow, onImageAvailable } = props;

  useEffect(() => {
    onImageAvailable?.(false);
    return () => onImageAvailable?.(false);
  }, [latestSelectedRow, onImageAvailable]);

  if (!latestSelectedRow) {
    return null;
  }
  return (
    <div
      id="searchandfilter-imgview-wrapper"
      className="w-full flex justify-center items-center shrink-0"
    >
      <WellDropImageLoader
        captureProfileId={latestSelectedRow.captureProfileId}
        plateId={latestSelectedRow.plateId}
        wellNumber={latestSelectedRow.wellNumber}
        batchId={latestSelectedRow.batchId}
        dropNumber={latestSelectedRow.dropNumber}
        regionId={latestSelectedRow.regionID}
        useCanvasImage={false}
        key={`Wi-${Object.values(latestSelectedRow).join('-')}`}
        className="h-[28vh] my-[10px]"
        onImageAvailable={onImageAvailable}
      />
    </div>
  );
};

export default ImgView;
